import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';


@Component({
  selector: 'app-offer-characteristic',
  templateUrl: './offer-characteristic.component.html',
  styleUrls: ['./offer-characteristic.component.css']
})
export class OfferCharacteristicComponent implements OnInit {
  @Input() editable: boolean;
  @Output() diffCharacteristicsEvent = new EventEmitter<CharacteristicsObject>();

  constructor() { }

  ngOnInit() { }

  onCharacteristicsChange($event: CharacteristicsObject) {
    this.diffCharacteristicsEvent.emit($event);
  }

}
